import { queryClient } from "app/providers/QueryProvider";

const REACT_QUERY_PERSIST_KEY = "REACT_QUERY_OFFLINE_CACHE";

export const clearAppQueryCache = () => {
  queryClient.clear();

  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(REACT_QUERY_PERSIST_KEY);
  } catch {
  }
};
